/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SeminarSessionConflictKind {
    SEMINAR = 'seminar',
    EVENT = 'event',
    EXTERNAL = 'external',
    INTERNAL = 'internal',
}
